module.exports = __webpack_public_path__ + "img/图片2.47391f9b.png";